<template lang="pug">
  v-container.fill-height(fluid='')
    v-row(
      align="center"
      justify="center"
    )
      v-col(
        cols='12'
        sm='8'
        md='6'
        lg='4'
        :class="{ 'px-0' : $vuetify.breakpoint.smAndDown }"
      )
        v-card.elevation-12
          v-toolbar(
            color='primary'
            dark
            flat
          )
            v-toolbar-title Reset Password
          v-card-text
            v-alert(
              v-if="requestSent"
              type="success"
              text
            ) If an account matches, we've emailed a reset link to the address on file. The link expires in 2 hours.
            v-alert(
              v-if="error"
              type="error"
              text
            ) {{ error }}
            v-form.pa-4(
              v-if="!requestSent"
              ref="form"
              v-model="valid"
              @submit.prevent="submit"
            )
              p Enter your username or email address and we'll send you a link to reset your password.
              v-text-field(
                filled
                label="Username or Email"
                v-model="identifier"
                name="username"
                autocomplete="username"
                :rules="[rules.required]"
              )
              v-btn.mt-2(
                block
                color="primary"
                type="submit"
                :disabled="!valid"
                :loading="sending"
                depressed
              ) Send Reset Link
            .text-center.mt-4
              | Email on file is out of date, or new to your shop?
              br
              router-link(:to="{ name: 'account-request' }") Request an account update
            .text-center.mt-4
              router-link(:to="{ name: 'login' }") Back to login
</template>

<script>
import validations from '@/mixins/validationRulesMixin'
import { requestPasswordReset } from '@/services/authManagement'

export default {
  name: 'RequestPasswordReset',
  mixins: [validations],
  data () {
    return {
      identifier: '',
      error: null,
      requestSent: false,
      sending: false
    }
  },
  methods: {
    async submit () {
      this.sending = true
      this.error = null

      try {
        await requestPasswordReset(this.identifier)
        this.requestSent = true
      } catch (error) {
        this.error = error.message
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
